// src/pages/DashboardPage.jsx
import React from "react";
import { Badge } from "../components/UI";

const StatCard = ({ icon, label, value, color }) => (
  <div style={{
    background: "#fff", border: "1px solid #e8f0e9", borderRadius: 14,
    padding: "20px 18px", borderLeft: `4px solid ${color}`,
  }}>
    <div style={{ fontSize: 28, marginBottom: 8 }}>{icon}</div>
    <div style={{ fontSize: 30, fontWeight: 900, color }}>{value}</div>
    <div style={{ fontSize: 12, color: "#777", fontWeight: 600, marginTop: 2 }}>{label}</div>
  </div>
);

export default function DashboardPage({ blogs, magazines, gallery, agriVideos, authors }) {
  const stats = [
    { label: "Total Blogs",      value: blogs.length,      icon: "📝", color: "#2d7a3a" },
    { label: "Magazines",        value: magazines.length,  icon: "📰", color: "#c05621" },
    { label: "Gallery Items",    value: gallery.length,    icon: "🖼️", color: "#2b6cb0" },
    { label: "AgriKnowledge",    value: agriVideos.length, icon: "🌱", color: "#6b46c1" },
    { label: "Authors",          value: authors.length,    icon: "👤", color: "#b7791f" },
  ];

  const published = blogs.filter(b => b.status === "published").length;
  const drafts    = blogs.filter(b => b.status === "draft").length;

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 900, color: "#1a1a1a", margin: "0 0 6px" }}>Dashboard</h2>
      <p style={{ fontSize: 14, color: "#888", margin: "0 0 24px" }}>Welcome back! Here's an overview of your content.</p>

      {/* Stats grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 14, marginBottom: 32 }}>
        {stats.map(s => <StatCard key={s.label} {...s} />)}
      </div>

      {/* Blog status row */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 32, maxWidth: 400 }}>
        <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "14px 16px" }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#15803d" }}>{published}</div>
          <div style={{ fontSize: 12, color: "#166534" }}>Published Blogs</div>
        </div>
        <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, padding: "14px 16px" }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#d97706" }}>{drafts}</div>
          <div style={{ fontSize: 12, color: "#92400e" }}>Draft Blogs</div>
        </div>
      </div>

      {/* Recent blogs table */}
      <h3 style={{ fontSize: 15, fontWeight: 800, color: "#333", margin: "0 0 12px" }}>Recent Blogs</h3>
      <div style={{ background: "#fff", border: "1px solid #eee", borderRadius: 12, overflow: "hidden" }}>
        {blogs.slice(0, 6).length ? (
          blogs.slice(0, 6).map((b, i) => (
            <div key={b.id} style={{
              padding: "13px 18px", borderBottom: i < Math.min(blogs.length, 6) - 1 ? "1px solid #f5f5f5" : "none",
              display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12,
            }}>
              <div style={{ display: "flex", gap: 12, alignItems: "center", minWidth: 0 }}>
                {b.thumbnailURL ? (
                  <img src={b.thumbnailURL} alt="" style={{ width: 44, height: 34, borderRadius: 6, objectFit: "cover", flexShrink: 0 }} />
                ) : (
                  <div style={{ width: 44, height: 34, borderRadius: 6, background: "#e8f5e9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>📝</div>
                )}
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {b.title || "Untitled"}
                  </div>
                  <div style={{ fontSize: 12, color: "#888" }}>{b.date} · {b.category || "General"}</div>
                </div>
              </div>
              <Badge color={b.status === "published" ? "#2d7a3a" : "#c05621"}>{b.status || "draft"}</Badge>
            </div>
          ))
        ) : (
          <div style={{ padding: "32px", textAlign: "center", color: "#bbb" }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>📝</div>
            <p style={{ margin: 0, fontSize: 13 }}>No blogs yet. Create your first blog from the Blogs section.</p>
          </div>
        )}
      </div>

      {/* Recent agriknowledge */}
      {agriVideos.length > 0 && (
        <>
          <h3 style={{ fontSize: 15, fontWeight: 800, color: "#333", margin: "28px 0 12px" }}>Recent AgriKnowledge Videos</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 12 }}>
            {agriVideos.slice(0, 4).map(v => (
              <div key={v.id} style={{ background: "#fff", border: "1px solid #eee", borderRadius: 10, overflow: "hidden" }}>
                <div style={{ height: 70, background: v.type === "youtube" ? "#ff000018" : "#1a1a2e18",
                  display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>
                  {v.thumbnailURL ? <img src={v.thumbnailURL} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    : (v.type === "youtube" ? "▶" : "🎞")}
                </div>
                <div style={{ padding: "10px 12px" }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a", marginBottom: 2 }}>{v.title}</div>
                  <div style={{ fontSize: 11, color: "#888" }}>By {v.contributorBy}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
